import type * as React from 'react'

// NOTE (Phase 00 contract gap, still open): reference/ICON-NORMALISATION.md §(c) specifies a
// shared `SvgIconProps` from './types.ts'. That file has no owning task in any phase file yet
// (flagged in PHASE-00's Notes as an open gap). This component must not create `./types.ts`
// unprompted, so the prop type is inlined here rather than imported. Once `./types.ts` exists,
// this local type should be replaced with an import from it to match every other icon component.
type SvgIconProps = Omit<React.SVGProps<SVGSVGElement>, 'children'> & {
  /** Accessible name. Omit for a purely decorative icon (default: aria-hidden). */
  title?: string
}

export function IconFolder16({ title, ...rest }: SvgIconProps) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.77539 2.00098C5.90766 2.00084 6.03883 2.0207 6.16406 2.06152L6.28809 2.10938L6.40625 2.16992C6.52041 2.23647 6.62383 2.32067 6.71191 2.41992L6.71094 2.4209L8.33691 4.25H13.5C13.8315 4.25 14.1494 4.38179 14.3838 4.61621C14.6182 4.85063 14.75 5.16848 14.75 5.5V12.5557C14.75 12.8724 14.6244 13.1764 14.4004 13.4004C14.1764 13.6244 13.8724 13.75 13.5557 13.75H2.45898C2.13863 13.7491 1.832 13.6211 1.60547 13.3945C1.37894 13.168 1.25093 12.8614 1.25 12.541V3.25C1.25 2.91848 1.38179 2.60063 1.61621 2.36621C1.85063 2.13179 2.16848 2 2.5 2L5.77539 2.00098ZM2.75 12.25H13.25V5.75H2.75V12.25ZM2.75 4.25H6.33008L5.66406 3.5H2.75V4.25Z"
        fill="currentColor"
      />
    </svg>
  )
}
